let $sessionObj = $('#session-timeout-dialog');
if ($sessionObj.length > 0) {
    (function ($) {
        'use strict';
        $.sessionTimeout = function (options) {
            var defaults = {
                keepAliveUrl: '/keep-alive',
                ajaxType: 'POST',
                ajaxData: '',
                redirUrl: '/timed-out',
                logoutUrl: '/log-out',
                warnAfter: 900000, // 15 minutes
                redirAfter: 1200000, // 20 minutes
                keepAliveInterval: 5000,
                keepAlive: true,
                ignoreUserActivity: false,
                onStart: false,
                onWarn: false,
                onRedir: false,
                countdownMessage: false,
                countdownBar: false,
                countdownSmart: false
            };
            var opt = defaults,
                timer,
                countdown = {};
            if (options) {
                opt = $.extend(defaults, options);
            }
            if (opt.warnAfter >= opt.redirAfter) {
                console.error('Bootstrap-session-timeout plugin is miss-configured. Option "redirAfter" must be equal or greater than "warnAfter".');
                return false;
            }
            if (typeof opt.onWarn !== 'function' && $('#session-timeout-dialog').length > 0) {
                var countdownMessage = opt.countdownMessage ? opt.countdownMessage.replace(/{timer}/g, '<span class="countdown-holder"></span>') : '';
                var coundownBarHtml = opt.countdownBar ?
                    '<div class="progress"> \
                        <div class="progress-bar progress-bar-striped countdown-bar active" role="progressbar" style="min-width: 15px; width: 100%;"> \
                            <span class="countdown-holder"></span> \
                        </div> \
                    </div>' : '';
                $('.countdownMessage').html(countdownMessage);
                $('.coundownBarHtml').append(coundownBarHtml);

                $('#session-timeout-logout').on('click', function () {
                    $('#session-timeout-dialog').hide();
                    window.location = opt.logoutUrl;
                });
                $('#session-timeout-keepalive').on('click', function () {
                    startSessionTimer();
                    $('#session-timeout-dialog').hide();
                });
                $('#session-timeout-dialog').on('click', '.content-popup-close', () => {
                    $('#session-timeout-keepalive').trigger('click');
                });
            }
            if (!opt.ignoreUserActivity) {
                var mousePosition = [-1, -1];
                $(document).on('keyup mouseup mousemove touchend touchmove', function (e) {
                    if (e.type === 'mousemove') {
                        if (e.clientX === mousePosition[0] && e.clientY === mousePosition[1]) {
                            return;
                        }
                        mousePosition[0] = e.clientX;
                        mousePosition[1] = e.clientY;
                    }
                    if (!$('#session-timeout-dialog').is(':visible')) {
                        startSessionTimer();
                    }
                });
            }
            var keepAlivePinged = false;
            function keepAlive() {
                if (!keepAlivePinged) {
                    $.ajax({
                        type: opt.ajaxType,
                        url: opt.keepAliveUrl,
                        data: opt.ajaxData
                    });
                    keepAlivePinged = true;
                    setTimeout(function () {
                        keepAlivePinged = false;
                        cLog('ping keep session alive every ' + opt.keepAliveInterval / 1000 + " seconds");
                    }, opt.keepAliveInterval);
                }
            }
            function startSessionTimer() {
                clearTimeout(timer);
                if (opt.countdownMessage || opt.countdownBar) {
                    startCountdownTimer('session', true);
                }
                if (typeof opt.onStart === 'function') {
                    opt.onStart(opt);
                }
                if (opt.keepAlive) {
                    keepAlive();
                }
                timer = setTimeout(function () {
                    if (typeof opt.onWarn !== 'function') {
                        $('#session-timeout-dialog').show();
                    } else {
                        opt.onWarn(opt);
                    }
                    startDialogTimer();
                }, opt.warnAfter);
            }
            function startDialogTimer() {
                clearTimeout(timer);
                if (!$('#session-timeout-dialog').hasClass('in') && (opt.countdownMessage || opt.countdownBar)) {
                    startCountdownTimer('dialog', true);
                }
                timer = setTimeout(function () {
                    if (typeof opt.onRedir !== 'function') {
                        $('#session-timeout-dialog').hide();
                        window.location = opt.redirUrl;
                    } else {
                        opt.onRedir(opt);
                    }
                }, (opt.redirAfter - opt.warnAfter));
            }
            function startCountdownTimer(type, reset) {
                clearTimeout(countdown.timer);
                if (type === 'dialog' && reset) {
                    countdown.timeLeft = Math.floor((opt.redirAfter - opt.warnAfter) / 1000);
                } else if (type === 'session' && reset) {

                    countdown.timeLeft = Math.floor(opt.redirAfter / 1000);
                }
                if (opt.countdownBar && type === 'dialog') {
                    countdown.percentLeft = Math.floor(countdown.timeLeft / ((opt.redirAfter - opt.warnAfter) / 1000) * 100);
                } else if (opt.countdownBar && type === 'session') {
                    countdown.percentLeft = Math.floor(countdown.timeLeft / (opt.redirAfter / 1000) * 100);
                }
                var countdownEl = $('.countdown-holder');
                var secondsLeft = countdown.timeLeft >= 0 ? countdown.timeLeft : 0;
                if (opt.countdownSmart) {
                    var minLeft = Math.floor(secondsLeft / 60);
                    var secRemain = secondsLeft % 60;
                    var countTxt = minLeft > 0 ? minLeft + 'm' : '';
                    if (countTxt.length > 0) {
                        countTxt += ' ';
                    }
                    countTxt += secRemain + 's.';
                    countdownEl.text(countTxt);
                } else {
                    countdownEl.text(secondsLeft + "s.");
                }
                if (opt.countdownBar) {
                    $('.countdown-bar').css('width', countdown.percentLeft + '%');
                }
                countdown.timeLeft = countdown.timeLeft - 1;
                countdown.timer = setTimeout(function () {

                    startCountdownTimer(type);
                }, 1000);
            }
            startSessionTimer();
        };
        $.sessionTimeout({
            keepAliveUrl: $sessionObj.data('keep-alive-url'),
            logoutUrl: $sessionObj.data('logout-url'),
            redirUrl: $sessionObj.data('redir-url'),
            warnAfter: $sessionObj.data('warn-after'),
            redirAfter: $sessionObj.data('redir-after'),
            keepAliveInterval: $sessionObj.data('keep-alive-interval'),
            countdownBar: $sessionObj.data('count-down-bar'),
            countdownMessage: $sessionObj.data('count-down-message')
        });
    })(jQuery);

}